//const BASEURL = 'http://localhost:8000'
const BASEURL = 'https://api.megahotmop.com'
export default BASEURL